export const splitter = (value: string) => {
  if (!value) return []
  return value.split(',').filter((i) => !!i)
}
